import axios from 'axios';

export async function upload(uri: string, file: File): Promise<any> {
  let uploadResponse = await axios.put(uri, file, {
    headers: {
      'Content-Type': file.type
    }
  });

  return uploadResponse
}

export async function download(downloadUrl: string): Promise<any> {
  let client = axios.create({
    responseType: 'blob'
  })
  let result = await client.get(downloadUrl);
  return result;
}